export function formatToLongDate(date: string): string {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  const [day, month, year] = date.split('/')
  const monthIndex = parseInt(month, 10) - 1

  return `${day} ${months[monthIndex]} ${year}`
}
